export default __webpack_public_path__ + "static/media/default-workshop.96ce63ed.png";